"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadOnlyBanner = ReadOnlyBanner;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
function ReadOnlyBanner(_a) {
    var feature = _a.feature, _b = _a.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", className: "inline-flex w-fit items-center gap-2 rounded-lg bg-surface-secondary px-3 py-1.5 text-xs text-muted ".concat(className), children: [(0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:lock-keyhole-minimalistic-linear", width: 14, className: "shrink-0" }), (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: "View only." }), " Ask an administrator for edit rights to ", feature, "."] })] }));
}
